import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-volt-detail-template',
  templateUrl: './volt-detail-template.component.html',
  styleUrls: ['./volt-detail-template.component.less']
})
export class VoltDetailTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
